export const warratiesPeriod = [
  {
    value: 'Nenhuma',
    label: 'Nenhuma',
  },
  {
    value: '1 mês',
    label: '1 mês',
  },
  {
    value: '3 meses',
    label: '3 meses',
  },
  {
    value: '6 meses',
    label: '6 meses',
  },
  {
    value: '12 meses',
    label: '12 meses',
  },
  {
    value: '24 meses',
    label: '24 meses',
  },
  {
    value: '36 meses',
    label: '36 meses',
  },
]
